import { createAction } from 'redux-actions';

import { reduxKey } from '../../constants';
import { createNetworkRequestActionSet } from '../utils';

export const setBlockedUsernamesWidgetBlockedUsers = createAction(
  `${reduxKey}.SET_BLOCKEDUSERNAMES_WIDGET_BLOCKED_USERS`,
  (blockedUsernames: string[]) => ({ blockedUsernames })
);

export const {
  submit: saveBlockedUsernames,
  success: saveBlockedUsernamesSuccess,
  failure: saveBlockedUsernamesFailure,
} = createNetworkRequestActionSet(reduxKey, 'SAVE_BLOCKED_USERNAMES');
